class GlideComponent extends HTMLElement {
  constructor() {
    super();
    this.instanceGlide = null;
    this.boxGlide = this.querySelector("#glide") ?? null;

    if (!this.boxGlide) return;

    this.nameSlide = this.boxGlide.getAttribute("data-slide") ?? "glide__slide";
    this.slidesGlide = this.querySelectorAll(`.${this.nameSlide}`);
    if (this.slidesGlide.length > 1) this.init();
  }

  init() {
    this.setInformations();
    if (this.initializeJustMobile) {
      addEventListener("resize", () => {
        this.verifyMediaQuery();
      });
      if (this.getWindowWidth() < this.mediaQueryActive) {
        this.startGlide();
      }

      return;
    }

    this.startGlide();
  }

  setInformations() {
    this.columns = this.boxGlide.getAttribute("data-columns")
      ? parseInt(this.boxGlide.getAttribute("data-columns"))
      : 6;
    this.columnsMobile = this.boxGlide.getAttribute("data-columnsMobile")
      ? this.boxGlide.getAttribute("data-columnsMobile")
      : 1;
    this.columnsTablet = this.boxGlide.getAttribute("data-columnsTablet")
      ? Number(this.boxGlide.getAttribute("data-columnsTablet"))
      : 1;
    this.showSliderMobile = this.boxGlide.getAttribute("data-enable-slider-mobile");
    this.type = this.boxGlide.getAttribute("data-type") ? this.boxGlide.getAttribute("data-type") : "slider";
    this.gap = this.boxGlide.getAttribute("data-gap") ? parseInt(this.boxGlide.getAttribute("data-gap")) : 10;
    this.rewind = this.boxGlide.getAttribute("data-rewind") ? this.boxGlide.getAttribute("data-rewind") : false;
    this.breakpointsTable = this.boxGlide.getAttribute("data-breakpoints-tablet") ? true : false;
    this.initializeJustMobile = this.boxGlide.getAttribute("data-just-mobile") ? true : false;
    this.mediaQueryActive = this.boxGlide.getAttribute("data-media-query-active")
      ? parseInt(this.boxGlide.getAttribute("data-media-query-active"))
      : 750;
    this.peekMobile = this.boxGlide.getAttribute("data-peek-mobile") ? { before: 50, after: 50 } : 0;
    this.peek = this.boxGlide.getAttribute("data-peek") ? { before: 300, after: 300 } : 0;
    this.activeGlide = false;
    this.autoplay = this.boxGlide.getAttribute("data-autoplay")
      ? parseInt(this.boxGlide.getAttribute("data-autoplay"))
      : false;
    this.is_inspiration = this.boxGlide.getAttribute("data-inspiration") ? { before: 130, after: 130 } : { before: 0, after: 0 };
  }

  options() {
    const breakpoints = {
      750: {
        gap: this.gap > 15 ? this.gap - 10 : this.gap,
        peek: this.peekMobile,
        perView: this.columnsMobile,
        swipeThreshold: this.showSliderMobile ? true : false,
        dragThreshold: this.showSliderMobile ? true : false,
        arrows: this.showSliderMobile ? true : false,
        keyboard: false,
      },
    };

    if (this.breakpointsTable) {
      breakpoints[1100] = {
        type: this.type,
        perView: this.columnsTablet,
        rewind: this.rewind,
        startAt: 0,
        autoplay: this.autoplay,
        bound: true,
        gap: this.gap,
        peek: this.is_inspiration,
      };
    }

    return {
      type: this.type,
      perView: this.columns,
      rewind: this.rewind,
      startAt: 0,
      autoplay: this.autoplay,
      bound: true,
      gap: this.gap,
      peek: this.peek,
      classes: {
        slider: this.nameSlide,
      },
      breakpoints: breakpoints,
    };
  }

  startGlide() {
    this.instanceGlide = new Glide(this.boxGlide, this.options()).mount();
    this.activeGlide = true;
  }

  verifyMediaQuery() {
    if (this.initializeJustMobile) {
      if (this.getWindowWidth() < this.mediaQueryActive) {
        if (!this.activeGlide && this.boxGlide) {
          this.startGlide();
        }
      }

      if (this.getWindowWidth() > this.mediaQueryActive) {
        if (this.activeGlide) {
          this.instanceGlide.destroy();
          this.activeGlide = false;
        }
      }
    } else {
      if (!this.activeGlide) {
        this.startGlide();
      }
    }
  }

  getWindowWidth() {
    return parseInt(document.getElementsByTagName("html")[0].clientWidth);
  }

  destroy() {
    this.instanceGlide.destroy();
  }

  mount() {
    this.init();
  }
}

customElements.define("glide-component", GlideComponent);
